import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Reservation {
  _id?: string;
  refNo?: string;
  userId: string;
  subscriberId: string;
  customerId: string;
  products: string[];
  status: string;
  expiryDate: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface CreateReservationRequest {
  customerId: string;
  products: string[];
  expiryDate: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ReservationService {
  private apiUrl = `${environment.apiUrl}/reservations`;

  constructor(private http: HttpClient) {}

  // Create reservation
  createReservation(data: CreateReservationRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/create`, data);
  }

  // Get all reservations
  getAllReservations(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  // Get reservation by ID
  getReservationById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  // Get reservations by customer ID
  getReservationsByCustomerId(customerId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/customer/${customerId}`);
  }

  // Get reservations by user ID
  getReservationsByUserId(userId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/user/${userId}`);
  }

  // Get reservations by subscriber ID
  getReservationsBySubscriberId(subscriberId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/subscriber/${subscriberId}`);
  }

  // Update reservation status
  updateReservationStatus(id: string, status: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/status`, { status });
  }
}
